__turbopack_context__.v({
  "arisMulti": "XaXz2q_arisMulti",
  "arisMultiValueLabel": "XaXz2q_arisMultiValueLabel",
  "arisNoOptionsMessage": "XaXz2q_arisNoOptionsMessage",
  "arisSelectContainer": "XaXz2q_arisSelectContainer",
  "arisSelectControl": "XaXz2q_arisSelectControl",
  "arisSelectDropdownIndicator": "XaXz2q_arisSelectDropdownIndicator",
  "arisSelectInput": "XaXz2q_arisSelectInput",
  "arisSelectOption": "XaXz2q_arisSelectOption",
  "arisSelectPlaceholder": "XaXz2q_arisSelectPlaceholder",
  "arisSelectSingleValue": "XaXz2q_arisSelectSingleValue",
  "arisValueContainer": "XaXz2q_arisValueContainer",
});
